var map = {
	"./el_bread_yellow_cart.png": 64307,
	"./en_bread_yellow_cart.png": 38313,
	"./it_bread_yellow_cart.png": 78223,
	"./ro_bread_yellow_cart.png": 43649,
	"./uk_bread_yellow_cart.png": 6820
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75297;